module.exports = __webpack_public_path__ + "img/pencil.4e4010a2.svg";